<template>
  <div v-if="!isLoggedIn">
    <nav class="fixed top-0 z-50 w-full bg-white border-b border-gray-200">
      <div class="px-3 py-3 lg:px-5 lg:pl-3">
        <div class="flex items-center justify-between">
          <div class="flex items-center justify-start rtl:justify-end">
            <button
              data-drawer-target="logo-sidebar"
              data-drawer-toggle="logo-sidebar"
              aria-controls="logo-sidebar"
              type="button"
              class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              <span class="sr-only">Open sidebar</span>
              <svg
                class="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                ></path>
              </svg>
            </button>
            <a href="#" class="flex ms-2 md:me-24">
              <img
                src="../../src/Img/excurix_logo.png"
                class="h-6 lg:h-8 me-3"
                alt="Excurix"
              />
            </a>
          </div>

          <!-- === Sección usuario + Dropdown === -->
          <div class="flex items-center gap-2 relative">
            <!-- Avatar -->
            <svg
              class="w-7 h-7 text-gray-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fill-rule="evenodd"
                d="M12 20a7.966 7.966 0 0 1-5.002-1.756l.002.001v-.683c0-1.794 1.492-3.25 3.333-3.25h3.334c1.84 0 3.333 1.456 3.333 3.25v.683A7.966 7.966 0 0 1 12 20ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.5-4.44 9.963-9.932 10h-.138C6.438 21.962 2 17.5 2 12Zm10-5c-1.84 0-3.333 1.455-3.333 3.25S10.159 13.5 12 13.5c1.84 0 3.333-1.455 3.333-3.25S13.841 7 12 7Z"
                clip-rule="evenodd"
              />
            </svg>

            <!-- Nombre + badge -->
            <div class="font-medium">
              <div v-if="displayName">{{ displayName }}</div>
              <div
                class="text-sm text-gray-500"
                :class="
                  tenant.subscription === 1
                    ? 'flex items-center text-green-500'
                    : 'flex items-center text-orange-500'
                "
              >
                <template v-if="store.role === 'owner'">OWNER</template>
                <template v-else>
                  {{
                    tenant.subscription === 1
                      ? "USUARIO PLUS"
                      : "USUARIO PRUEBA"
                  }}
                </template>
              </div>
            </div>

            <!-- Botón dropdown (chevron) -->
            <button
              id="dropdownUserButton"
              data-dropdown-toggle="dropdownUserMenu"
              type="button"
              class="p-1 rounded hover:bg-gray-100 focus:outline-none"
              aria-label="Abrir menú de usuario"
            >
              <svg
                class="w-5 h-5 text-gray-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.187l3.71-3.956a.75.75 0 011.08 1.04l-4.24 4.52a.75.75 0 01-1.08 0l-4.24-4.52a.75.75 0 01.02-1.06z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>

            <!-- Menú -->
            <div
              id="dropdownUserMenu"
              class="z-50 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44"
            >
              <ul
                class="py-2 text-sm text-gray-700"
                aria-labelledby="dropdownUserButton"
              >
                <li>
                  <a
                    href="#"
                    @click.prevent="navigateTo('/perfil')"
                    class="block px-4 py-2 hover:bg-gray-100"
                    >Perfil</a
                  >
                </li>
                <li>
                  <a
                    href="#"
                    @click.prevent="logout()"
                    class="block px-4 py-2 hover:bg-gray-100"
                    >Salir</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- === /Sección usuario + Dropdown === -->
        </div>
      </div>
    </nav>

    <button
      data-drawer-target="logo-sidebar"
      data-drawer-toggle="logo-sidebar"
      aria-controls="logo-sidebar"
      type="button"
      class="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
    >
      <svg
        class="w-6 h-6"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          clip-rule="evenodd"
          fill-rule="evenodd"
          d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
        ></path>
      </svg>
    </button>

    <aside
      id="logo-sidebar"
      class="fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0"
      aria-label="Sidebar"
    >
      <div class="h-full px-3 py-4 overflow-y-auto bg-gray-50">
        <a
          href="#"
          @click.prevent="navigateTo('/caja')"
          class="flex items-center ps-2.5 mb-5"
        >
          <img
            src="../Img/excurix_logo.png"
            class="h-6 me-3 sm:h-7"
            alt="Excurix Logo"
          />
        </a>

        <!-- ===== Tu menú (sin cambios funcionales) ===== -->
        <ul class="space-y-2 font-medium">
          <li v-if="store.role == 'admin'">
            <a
              href="#"
              @click.prevent="navigateTo('/agenda-calendario')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M19 4h-1V2a1 1 0 0 0-2 0v2H8V2a1 1 0 0 0-2 0v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 16H5V9h14Zm0-11H5V6h14Z"
                />
              </svg>
              <span
                class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap"
                >Agenda / Calendario</span
              >
            </a>
          </li>

          <li v-if="store.role == 'admin'">
            <a
              href="#"
              @click.prevent="navigateTo('/vistageneral')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 18 18"
              >
                <path
                  d="M6.143 0H1.857A1.857 1.857 0 0 0 0 1.857v4.286C0 7.169.831 8 1.857 8h4.286A1.857 1.857 0 0 0 8 6.143V1.857A1.857 1.857 0 0 0 6.143 0Zm10 0h-4.286A1.857 1.857 0 0 0 10 1.857v4.286C10 7.169 10.831 8 11.857 8h4.286A1.857 1.857 0 0 0 18 6.143V1.857A1.857 1.857 0 0 0 16.143 0Zm-10 10H1.857A1.857 1.857 0 0 0 0 11.857v4.286C0 17.169.831 18 1.857 18h4.286A1.857 1.857 0 0 0 8 16.143v-4.286A1.857 1.857 0 0 0 6.143 10Zm10 0h-4.286A1.857 1.857 0 0 0 10 11.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 18 16.143v-4.286A1.857 1.857 0 0 0 16.143 10Z"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Panel</span>
            </a>
          </li>

          <li v-if="store.role == 'admin'">
            <a
              href="#"
              @click.prevent="navigateTo('/caja')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 22 21"
              >
                <path
                  d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z"
                />
                <path
                  d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z"
                />
              </svg>
              <span class="ms-3">Caja</span>
            </a>
          </li>

          <li v-if="store.role == 'admin'">
            <a
              href="#"
              @click.prevent="navigateTo('/reservas')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm3-7h.01v.01H8V13Zm4 0h.01v.01H12V13Zm4 0h.01v.01H16V13Zm-8 4h.01v.01H8V17Zm4 0h.01v.01H12V17Zm4 0h.01v.01H16V17Z"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Reservas</span>
            </a>
          </li>

          <li v-if="store.role == 'admin'">
            <button
              type="button"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100"
              aria-controls="dropdown-finanzas"
              data-collapse-toggle="dropdown-finanzas"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm-1-13h2v6h-2zm0 8h2v2h-2z"
                />
              </svg>
              <span
                class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap"
                >Finanzas</span
              >
              <svg
                class="w-3 h-3"
                aria-hidden="true"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </button>
            <ul id="dropdown-finanzas" class="hidden py-2 space-y-2">
              <li>
                <a
                  href="#"
                  @click.prevent="navigateTo('/ingresos')"
                  class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100"
                  >Ingresos</a
                >
              </li>
              <li>
                <a
                  href="#"
                  @click.prevent="navigateTo('/egresos')"
                  class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100"
                  >Egresos</a
                >
              </li>
            </ul>
          </li>

          <li v-if="store.role == 'admin'">
            <a
              href="#"
              @click.prevent="navigateTo('/ventas')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 18 20"
              >
                <path
                  d="M17 5.923A1 1 0 0 0 16 5h-3V4a4 4 0 1 0-8 0v1H2a1 1 0 0 0-1 .923L.086 17.846A2 2 0 0 0 2.08 20h13.84a2 2 0 0 0 1.994-2.153L17 5.923ZM7 9a1 1 0 0 1-2 0V7h2v2Zm0-5a2 2 0 1 1 4 0v1H7V4Zm6 5a1 1 0 1 1-2 0V7h2v2Z"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Ventas</span>
            </a>
          </li>

          <li v-if="store.role !== 'owner'">
            <a
              href="#"
              @click.prevent="navigateTo('/pendientes')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                fill="currentColor"
                viewBox="0 0 512 512"
              >
                <path
                  d="M438.251,0H319.998h-128H73.749C33.018,0,0,33.018,0,73.749v364.501C0,478.982,33.018,512,73.749,512h364.501 C478.982,512,512,478.982,512,438.251V73.749C512,33.018,478.982,0,438.251,0z M298.665,42.667v66.805l-30.833-20.555 c-7.166-4.777-16.501-4.777-23.667,0l-30.833,20.555V42.667H298.665z M469.333,438.251c0,17.167-13.915,31.083-31.083,31.083 H73.749c-17.167,0-31.083-13.915-31.083-31.083V73.749c0-17.167,13.915-31.083,31.083-31.083h96.915v106.667 c0,17.039,18.99,27.202,33.167,17.75l52.166-34.778l52.166,34.778c14.177,9.451,33.167-0.712,33.167-17.75V42.667h96.919 c17.167,0,31.083,13.915,31.083,31.083V438.251z"
                ></path>
                <path
                  d="M185.749,219.582c-0.497-0.497-1.02-0.967-1.564-1.413c-0.246-0.202-0.505-0.377-0.757-0.566 c-0.305-0.228-0.603-0.464-0.919-0.676c-0.303-0.203-0.617-0.378-0.928-0.564c-0.287-0.171-0.567-0.351-0.862-0.51 c-0.317-0.169-0.642-0.313-0.965-0.465c-0.308-0.146-0.611-0.299-0.927-0.43c-0.313-0.13-0.633-0.234-0.951-0.348 c-0.339-0.122-0.673-0.252-1.019-0.356c-0.318-0.096-0.641-0.167-0.963-0.248c-0.353-0.089-0.702-0.188-1.061-0.259 c-0.372-0.074-0.747-0.117-1.122-0.171c-0.314-0.045-0.623-0.105-0.941-0.136c-1.4-0.138-2.81-0.138-4.21,0 c-0.318,0.031-0.627,0.091-0.94,0.136c-0.375,0.054-0.75,0.098-1.122,0.171c-0.359,0.071-0.708,0.17-1.061,0.259 c-0.322,0.081-0.645,0.151-0.964,0.248c-0.346,0.105-0.68,0.234-1.018,0.356 c-0.318,0.114-0.639,0.219-0.953,0.349 c-0.316,0.131-0.618,0.284-0.926,0.43 c-0.323,0.152-0.649,0.296-0.966,0.465 c-0.295,0.158-0.575,0.338-0.861,0.509 c-0.311,0.186-0.626,0.361-0.929,0.564 c-0.316,0.211-0.613,0.447-0.917,0.674 c-0.253,0.19-0.513,0.365-0.759,0.568 c-0.544,0.446-1.067,0.916-1.563,1.413l-42.667,42.667c-8.331,8.331-8.331,21.839,0,30.17 s21.839,8.331,30.17,0l6.248-6.248 v119.163c0,11.782,9.551,21.333,21.333,21.333c11.782,0,21.333-9.551,21.333-21.333V286.17 l6.248,6.248c8.331,8.331,21.839,8.331,30.17,0s8.331-21.839,0-30.17L185.749,219.582z"
                ></path>
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Pendientes</span>
            </a>
          </li>

          <li v-if="store.role !== 'owner'">
            <a
              href="#"
              @click.prevent="navigateTo('/presupuesto')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H9M15 5H17C18.1046 5 19 5.89543 19 7V9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.902 20.3343L12.7153 20.7716L13.1526 18.585C13.1914 18.3914 13.2865 18.2136 13.4261 18.074L17.5 14L19.5 12L21.4869 13.9869L19.4869 15.9869L15.413 20.0608C15.2734 20.2004 15.0956 20.2956 14.902 20.3343Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Presupuestos</span>
            </a>
          </li>

          <li v-if="store.role == 'admin'">
            <a
              href="#"
              @click.prevent="navigateTo('/servicios')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M18.045 3.007 12.31 3a1.965 1.965 0 0 0-1.4.585l-7.33 7.394a2 2 0 0 0 0 2.805l6.573 6.631a1.957 1.957 0 0 0 1.4.585 1.965 1.965 0 0 0 1.4-.585l7.409-7.477A2 2 0 0 0 21 11.479v-5.5a2.972 2.972 0 0 0-2.955-2.972Zm-2.452 6.438a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Servicios</span>
            </a>
          </li>

          <li v-if="store.role == 'admin'">
            <a
              href="#"
              @click.prevent="navigateTo('/tipoServicios')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15.583 8.445h.01M10.86 19.71l-6.573-6.63a.993.993 0 0 1 0-1.4l7.329-7.394A.98.98 0 0 1 12.31 4l5.734.007A1.968 1.968 0 0 1 20 5.983v5.5a.992.992 0 0 1-.316.727l-7.44 7.5a.974.974 0 0 1-1.384.001Z"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap"
                >Tipos de servicios</span
              >
            </a>
          </li>

          <li v-if="store.role == 'admin'">
            <a
              href="#"
              @click.prevent="navigateTo('/clientes')"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  d="M9 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4H7Zm8-1a1 1 0 0 1 1-1h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 0 1-1-1Z"
                  clip-rule="evenodd"
                />
              </svg>

              <span class="flex-1 ms-3 whitespace-nowrap">Clientes</span>
            </a>
          </li>
        </ul>

        <ul class="space-y-2 font-medium">
          <li v-if="store.role == 'owner'">
            <a
              href="#"
              @click.prevent="navigateTo('/owner/dashboard')"
              :class="[
                'flex items-center p-2 rounded-lg group',
                isActive('/owner/dashboard')
                  ? 'bg-emerald-100 text-emerald-700'
                  : 'text-gray-900 hover:bg-gray-100',
              ]"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M3 13h8V3H3v10zm0 8h8v-6H3v6zM13 21h8V11h-8v10zM13 3v6h8V3h-8z"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Owner Dashboard</span>
            </a>
          </li>
          <li v-if="store.role == 'owner'">
            <a
              href="#"
              @click.prevent="navigateTo('/owner/leadsAdmin')"
              :class="[
                'flex items-center p-2 rounded-lg group',
                isActive('/owner/leadsAdmin')
                  ? 'bg-emerald-100 text-emerald-700'
                  : 'text-gray-900 hover:bg-gray-100',
              ]"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path fill-rule="evenodd" d="M7 2a2 2 0 0 0-2 2v1a1 1 0 0 0 0 2v1a1 1 0 0 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7Zm3 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-1 7a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3 1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1Z" clip-rule="evenodd"/>
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Prospectos</span>
            </a>
          </li>
          <li v-if="store.role == 'owner'">
            <a
              href="#"
              @click.prevent="navigateTo('/owner/usuariosadmin')"
              :class="[
                'flex items-center p-2 rounded-lg group',
                isActive('/owner/usuariosadmin')
                  ? 'bg-emerald-100 text-emerald-700'
                  : 'text-gray-900 hover:bg-gray-100',
              ]"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 18"
              >
                <path
                  d="M14 2a3.963 3.963 0 0 0-1.4.267 6.439 6.439 0 0 1-1.331 6.638A4 4 0 1 0 14 2Zm1 9h-1.264A6.957 6.957 0 0 1 15 15v2a2.97 2.97 0 0 1-.184 1H19a1 1 0 0 0 1-1v-1a5.006 5.006 0 0 0-5-5ZM6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM8 10H5a5.006 5.006 0 0 0-5 5v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a5.006 5.006 0 0 0-5-5Z"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Usuarios</span>
            </a>
          </li>
          <li v-if="store.role == 'owner'">
            <a
              href="#"
              @click.prevent="navigateTo('/owner/empresasadmin')"
              :class="[
                'flex items-center p-2 rounded-lg group',
                isActive('/owner/empresasadmin')
                  ? 'bg-emerald-100 text-emerald-700'
                  : 'text-gray-900 hover:bg-gray-100',
              ]"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 2c-.791 0-1.55.314-2.11.874l-.893.893a.985.985 0 0 1-.696.288H7.04A2.984 2.984 0 0 0 4.055 7.04v1.262a.986.986 0 0 1-.288.696l-.893.893a2.984 2.984 0 0 0 0 4.22l.893.893a.985.985 0 0 1 .288.696v1.262a2.984 2.984 0 0 0 2.984 2.984h1.262c.261 0 .512.104.696.288l.893.893a2.984 2.984 0 0 0 4.22 0l.893-.893a.985.985 0 0 1 .696-.288h1.262a2.984 2.984 0 0 0 2.984-2.984V15.7c0-.261.104-.512.288-.696l.893-.893a2.984 2.984 0 0 0 0-4.22l-.893-.893a.985.985 0 0 1-.288-.696V7.04a2.984 2.984 0 0 0-2.984-2.984h-1.262a.985.985 0 0 1-.696-.288l-.893-.893A2.984 2.984 0 0 0 12 2Zm3.683 7.73a1 1 0 1 0-1.414-1.413l-4.253 4.253-1.277-1.277a1 1 0 0 0-1.415 1.414l1.985 1.984a1 1 0 0 0 1.414 0l4.96-4.96Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Empresas</span>
            </a>
          </li>
        </ul>

        <ul class="pt-4 mt-4 space-y-2 font-medium border-t border-gray-200">
          <li>
            <a
              href="#"
              @click.prevent="logout()"
              class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
            >
              <svg
                class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900"
                aria-hidden="true"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2"
                />
              </svg>
              <span class="flex-1 ms-3 whitespace-nowrap">Cerrar Sesión</span>
            </a>
          </li>
        </ul>

        <!-- Botones extra -->
        <div class="p-1 mt-6">
          <div class="flex items-end justify-contennt-center h-24">
            <div class="inline-flex rounded-md shadow-sm" role="group">
              <a
                href="https://youtube.com/playlist?list=PLoZPRkkeJxI3bm5eUqfeC46hUofuf7d9l&si=tgBgKRztrQO_7MAL"
                target="_blank"
              >
                <button
                  type="button"
                  class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-[#3edfa9] focus:z-10 focus:ring-2 focus:ring-[#3edfa9] focus:text-[#3edfa9]"
                >
                  <svg class="w-6 h-6 me-1" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M19.67 8.14002C19.5811 7.7973 19.4028 7.48433 19.1533 7.23309C18.9038 6.98185 18.5921 6.80134 18.25 6.71001C16.176 6.4654 14.0883 6.35517 12 6.38001C9.91174 6.35517 7.82405 6.4654 5.75001 6.71001C5.40793 6.80134 5.09622 6.98185 4.84674 7.23309C4.59725 7.48433 4.41894 7.7973 4.33001 8.14002C4.10282 9.41396 3.99236 10.706 4.00001 12C3.99198 13.3007 4.10244 14.5994 4.33001 15.88C4.42355 16.2172 4.60391 16.5239 4.85309 16.7696C5.10226 17.0153 5.41153 17.1913 5.75001 17.28C7.82405 17.5246 9.91174 17.6349 12 17.61C14.0883 17.6349 16.176 17.5246 18.25 17.28C18.5885 17.1913 18.8978 17.0153 19.1469 16.7696C19.3961 16.5239 19.5765 16.2172 19.67 15.88C19.8976 14.5994 20.008 13.3007 20 12C20.0077 10.706 19.8972 9.41396 19.67 8.14002ZM10.36 14.39V9.63001L14.55 12L10.36 14.38V14.39Z"
                      fill="#ff0000"
                    ></path>
                  </svg>
                  Tutoriales
                </button>
              </a>

              <a
                type="button"
                href="https://api.whatsapp.com/send/?phone=5493544449149"
                target="_blank"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-[#3edfa9] focus:z-10 focus:ring-2 focus:ring-[#3edfa9] focus:text-[#3edfa9]"
              >
                <svg class="w-4 h-4 me-1" viewBox="0 0 58 58" fill="#000000">
                  <path
                    style="fill: #2cb742"
                    d="M0,58l4.988-14.963C2.457,38.78,1,33.812,1,28.5C1,12.76,13.76,0,29.5,0S58,12.76,58,28.5 S45.24,57,29.5,57c-4.789,0-9.299-1.187-13.26-3.273L0,58z"
                  ></path>
                  <path
                    style="fill: #ffffff"
                    d="M47.683,37.985c-1.316-2.487-6.169-5.331-6.169-5.331c-1.098-0.626-2.423-0.696-3.049,0.42 c0,0-1.577,1.891-1.978,2.163c-1.832,1.241-3.529,1.193-5.242-0.52l-3.981-3.981l-3.981-3.981c-1.713-1.713-1.761-3.41-0.52-5.242 c0.272-0.401,2.163-1.978,2.163-1.978c1.116-0.627,1.046-1.951,0.42-3.049c0,0-2.844-4.853-5.331-6.169 c-1.058-0.56-2.357-0.364-3.203,0.482l-1.758,1.758c-5.577,5.577-2.831,11.873,2.746,17.45l5.097,5.097l5.097,5.097 c5.577,5.577,11.873,8.323,17.45,2.746l1.758-1.758C48.048,40.341,48.243,39.042,47.683,37.985z"
                  ></path>
                </svg>
                Soporte
              </a>
            </div>
          </div>
        </div>
      </div>
    </aside>

    <div class="sm:ml-64">
      <div class="sm:mt-10 mt-2">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import authService from "../composables/api/authService.js";
import tenantService from "../composables/api/tenantService.js";
import { store } from "../store.js";
import { initFlowbite } from "flowbite";
import { goToLogin } from "../router";

const props = defineProps({
  isLoggedIn: Boolean,
  role: String,
});

const tenant = ref({ subscription: 1 });
const error = ref("");

const router = useRouter();
const route = useRoute();

const isActive = (prefix) => {
  try {
    return route.path && route.path.startsWith(prefix);
  } catch {
    return false;
  }
};

const logout = async () => {
  await authService.logout();
  try {
    localStorage.removeItem("jwt-token");
  } catch {}
  store.user = null;
  store.role = "guest";
  try {
    goToLogin();
  } catch {
    router.push({ name: "Login" }).catch(() => {
      const basePath = window.location.pathname.replace(/\/$/, "");
      window.location.href = `${basePath}/login`;
    });
  }
};

const navigateTo = (to) => {
  router.push(to);
};

// ===== Header: mostrar nombre =====
const usuario = ref({});
const tenantInfo = ref(null);

const displayName = computed(() => {
  if (tenantInfo.value?.name && String(tenantInfo.value.name).trim())
    return tenantInfo.value.name;
  if (usuario.value?.name && String(usuario.value.name).trim())
    return usuario.value.name;
  if (usuario.value?.userName && String(usuario.value.userName).trim())
    return usuario.value.userName;
  const full = [usuario.value?.nombre, usuario.value?.apellido]
    .filter(Boolean)
    .join(" ")
    .trim();
  if (full) return full;
  return usuario.value?.email || "Usuario";
});

const fetchUsuarioYTenant = async () => {
  try {
    const current = await authService.getCurrentUser();
    usuario.value = current;

    if (current?.tenantId) {
      const t = await tenantService.getTenantByTenantId(current.tenantId);
      tenantInfo.value = t || null;
    } else {
      tenantInfo.value = null;
    }
  } catch (err) {
    error.value =
      "Error al cargar el usuario/tenant: " + (err?.message || String(err));
    console.error(err);
  }
};

onMounted(async () => {
  initFlowbite(); // Necesario para el dropdown por data attributes
  await fetchUsuarioYTenant();

  const currentUser = usuario.value;
  store.user = currentUser;

  if (currentUser?.roles?.length) {
    store.role = currentUser.roles[0].toLowerCase() || "guest";
  } else {
    store.role = "guest";
  }
});
</script>
